var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"overlay-close",class:{ 'overlay-close--active': _vm.overlay != '' },on:{"click":function($event){$event.preventDefault();return _vm.$store.commit('overlay/set', '')}}})}
var staticRenderFns = []

export { render, staticRenderFns }